import { styled, keyframes, css } from '@mui/material/styles';
import { ListLayoutVariant } from 'core/flow/entities';
import { AnimationTypes } from './types';

const slideIn = keyframes`
  0% {
    opacity: 0;
    visibility: hidden;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
`;

export const AnswerListItemStyled = styled('li')<{
  isAnimate: boolean;
  index: number;
  animationVariant: AnimationTypes;
}>(
  ({ animationVariant, isAnimate, index }) => css`
    height: 100%;
    visibility: hidden;

    ${animationVariant === AnimationTypes.FADE_SLIDE &&
    css`
      opacity: ${isAnimate ? 0 : 1};
      animation: ${isAnimate ? slideIn : 'none'} 0.7s ease ${index * 0.2}s forwards;
    `}
  `,
);

export const AnswerListStyled = styled('ul')<{ layoutVariant: ListLayoutVariant }>`
  display: flex;
  flex-wrap: wrap;

  ${({ layoutVariant }) => {
    if (layoutVariant === ListLayoutVariant.TILE) {
      return 'justify-content: space-between;';
    }
  }}

  li {
    ${({ layoutVariant }) => {
      if (layoutVariant === ListLayoutVariant.COLUMN) {
        return `width: 100%;`;
      }
      if (layoutVariant === ListLayoutVariant.TILE) {
        return `width: calc(50% - 6px);`;
      }
      return `width: auto;`;
    }}
  }
`;
